const LAST_ROUTE_KEY = 'tegrat_last_route';
const ROUTE_TTL = 24 * 60 * 60 * 1000; // 24 hours

export const saveLastRoute = (pathname) => {
  if (!pathname.includes('/login')) {
    localStorage.setItem(LAST_ROUTE_KEY, JSON.stringify({
      path: pathname,
      timestamp: Date.now()
    }));
  }
};

export const getLastRoute = () => {
  const saved = localStorage.getItem(LAST_ROUTE_KEY);
  if (!saved) return null;

  try {
    const { path, timestamp } = JSON.parse(saved);
    if (Date.now() - timestamp > ROUTE_TTL) {
      clearLastRoute();
      return null;
    }
    return path;
  } catch (error) {
    console.error('Error parsing saved route:', error);
    clearLastRoute();
    return null;
  }
};

export const clearLastRoute = () => {
  localStorage.removeItem(LAST_ROUTE_KEY);
};
